import React from "react";
import "./component.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button"

const RechargeComponent = (props) => {
  return (
    <div className="form-row">
      <Box className="form-field">
        <h3 style={{ color: "var(--blue)" }}>+ Monthly</h3>
        <TextField
          fullWidth
          label="Amount"
          type="number"
          name="amount"
          value={props.rechargeData.monthly.amount}
          onChange={(e) => props.handleChangeRecharge(e, "monthly")}
        />
        <div>
          <label className="couponLabelRecharge">
            Revoke remaining balance at the end of the month
          </label>
          <div className="toggle-group">
            <Button
              className={`toggle-button ${props.activeBtn1 === "Yes" ? "active" : "deleted"}`}
              onClick={() => {
                props.handleAddRechargeBtnClick1("Yes");
                props.handleResetBalanceChange(false);
              }}
            >
              Yes
            </Button>
            <Button
              className={`toggle-button ${props.activeBtn1 === "No" ? "active" : "deleted"}`}
              onClick={() => {
                props.handleAddRechargeBtnClick1("No");
                props.handleResetBalanceChange(true);
              }}
            >
              No
            </Button>
          </div>
        </div>

        <h3 style={{ color: "var(--blue)", marginTop: "2rem" }}>+ Add on</h3>
        <div className="toggle-group">
          <Button
            className={`toggle-button ${props.activeBtn === "Yes" ? "active" : "deleted"}`}
            onClick={() => props.setActiveBtn("Yes")}
          >
            Yes
          </Button>
          <Button
            className={`toggle-button ${props.activeBtn === "No" ? "active" : "deleted"}`}
            onClick={() => props.setActiveBtn("No")}
          >
            No
          </Button>
        </div>

        {props.activeBtn === "Yes" && (
          <>
            <TextField
              fullWidth
              label="Add-on Amount"
              type="number"
              name="amount"
              value={props.rechargeData.add_on.amount}
              onChange={(e) => props.handleChangeRecharge(e, "add_on")}
              style={{ marginTop: "1rem" }}
            />
            <TextField
              fullWidth
              label="Low Balance"
              type="number"
              name="low_balance"
              value={props.rechargeData.add_on.low_balance}
              onChange={(e) => props.handleChangeRecharge(e, "add_on")}
              style={{ marginTop: "1rem" }}
            />
          </>
        )}
      </Box>
    </div>
  );
};

export default RechargeComponent;